export default {
    educationalGroups:          { method: 'get',    url: 'educational_groups' },
    educationalGroupCreate:     { method: 'post',   url: 'educational_groups' },
    educationalGroupUpdate:     { method: 'put',    url: 'educational_groups/{id}' },
    educationalGroupDelete:     { method: 'delete', url: 'educational_groups/{id}' },
}